module.exports = __webpack_public_path__ + "media/phase-1-complete.2a2e93bb.mp4";